import { InternshipPackView } from 'views/InternshipPack/InternshipPackView/InternshipPackView';
import { InternshipPackInfo } from 'views/InternshipPack/InternshipPackInfo/InternshipPackInfo';
import { UserInternshipPackInfo } from 'views/InternshipPack/UserInternshipPackInfo/UserInternshipPackInfo';

const routes = [
    {
        path: '/internships',
        view: InternshipPackView,
        layout: 'app',
        permission: 'internship.view',
        title: 'InternshipPack.InternshipPackView.title'
    },
    {
        path: '/internships/info/:internship_id',
        view: InternshipPackInfo,
        layout: 'app',
        permission: 'internship.info.view',
        title: 'InternshipPack.InternshipPackInfo.title.buy'
    },
    {
        path: '/internships/:internship_id/info',
        view: UserInternshipPackInfo,
        layout: 'app',
        permission: 'internship.user.view',
        title: 'InternshipPack.UserInternshipPackInfo.title'
    }
];

export default routes;
